import React, {useContext, useEffect, useState, useMemo} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../shared/styles/CardArticleForm.css";

import "../../shared/styles/HomeDefault.css";

import { useAuth } from "../../shared/auth/AuthProvider";

import { Container, Nav, Navbar, NavDropdown, Form, Button, Image, Carousel, Row, Col, Card, Tabs, Tab, Spinner, Badge } from 'react-bootstrap'

/* import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons"; */


/* 
import { firestore } from '../../database/firebase';
import { auth } from '../../database/firebase';
import { AuthContext } from '../Old_Test/Auth'; */

import { Link, Navigate } from "react-router-dom";

import { FaHeart, FaTruck, FaFacebookMessenger } from "react-icons/fa";
import NewestArticle from '../../features/home/components/NewestArticle';
// import { BsStarFill, BsStarHalf, BsStar, BsBagHeart } from "react-icons/bs";


import Test_Ads_03 from "../../assets/Test_Ads_03.png";
import Test_Ads_04 from "../../assets/Test_Ads_04.png";
import Test_Ads_05 from "../../assets/Test_Ads_05.png";

import Ads_Encraft_06 from "../../assets/Ads_Encraft_06.png";
import Ads_Encraft_07 from "../../assets/Ads_Encraft_07.png";
import Ads_Encraft_08 from "../../assets/Ads_Encraft_08.png";

import ChicChic_hero from "../../assets/ChicChic_hero.png";
import ChicChic_hero_01 from "../../assets/ChicChic_hero_01.png";
import ChicChic_hero_02 from "../../assets/ChicChic_hero_02.png";
import tutor_2026 from "../../assets/tutor-2026.JPG";


import BrowseCategory from '../../features/home/components/BrowseCategory';
// import CardsLayout from '../../features/home/components/CardsLayout';
import RecommendedArticleListWideSection from '../../features/home/components/RecommendedArticleListWideSection';
import UpdateArticle from '../../features/home/components/UpdateArticle';
import LoginPromptSection from '../../features/home/components/LoginPromptSection';
import VideoRowScrollMock from '../courses/CourseVideoGalleryPage';
import UpdateCourseMock from '../courses/UpdateCourseMock';
import CourseUpdate from '../../features/home/components/CourseUpdate';
import VideoUpdate from '../../features/home/components/VideoUpdate';
import RecommendedVideoListWideSection from '../../features/home/components/RecommendedVideoListWideSection';
import MyCoursesSlide from '../../features/home/components/MyCoursesSlide';
import Course2_79 from '../../features/home/components/Course2_79';
import HomepageReviews from '../../features/home/components/HomepageReviews';
import CourseCalendarSlide from '../../features/home/components/CourseCalendarSlide';
import CourseScheduleSlide from '../../features/home/components/CourseScheduleSlide';
import YoutubePodcastUpdate from '../../features/home/components/YoutubePodcastUpdate';


function HomeDefault() {

    

    // ใน HomeDefault.js (ส่วนบน)
    const [selectedCategory, setSelectedCategory] = useState("all");

    const categoryBadges = useMemo(
    () => [
        { slug: "all", name: "ทั้งหมด" },
        { slug: "เนติบัณฑิต", name: "เนติบัณฑิต" },
        { slug: "ทนายความ", name: "ทนายความ" },
        { slug: "อัยการ", name: "อัยการ" },
        { slug: "ผู้พิพากษา", name: "ผู้พิพากษา" },
        { slug: "สอบ ก.พ.", name: "สอบ ก.พ." },
    ],
    []
    );

    const { userDoc } = useAuth();
    const role = userDoc?.role;              // บางโปรเจคเป็น string
    const roles = userDoc?.roles;            // บางโปรเจคเป็น array (เผื่อไว้)

    const isAdmin =
    String(role || "").toLowerCase() === "admin" ||
    (Array.isArray(roles) && roles.map(x => String(x).toLowerCase()).includes("admin"));
    

    return (
        
        <div>

            {/* <Container> */}
               {/*  <img
                    className="d-block w-100"
                    src={Test_Ads_05}
                    alt="Second slide"
                    style={{borderRadius: 10}}
                /> */}
                

             {/*    <br/>
            </Container> */}

            <Container>
                {/* ✅ Header ตัวหน้า + Badge */}
                <div className="mb-4">
                <h2 className="mb-2">
                    <strong>ChicChic Law Tutor</strong>
                </h2>

                <div className="subcategory-scroll mb-0">
                    {categoryBadges.map((cat) => (
                    <Button
                        key={cat.slug}
                        className={`subcategory-btn ${
                            selectedCategory === cat.slug ? "active" : ""
                        }`}
                        onClick={() => setSelectedCategory(cat.slug)}
                        >
                        {cat.name}
                    </Button>
                    ))}
                </div>
                </div>
                    {/* <UpdateCourseMock /> */}
                    {/* ✅ คอร์สแนะนำ (รับ category จากด้านบน) */}

                    {/* {isAdmin && (
                    <MyCoursesSlide
                        selectedCategory={selectedCategory}
                        moreTo="/courses"
                    />
                    )} */}
                    
                   {/*  {isAdmin && (
                    <CourseUpdate
                        selectedCategory={selectedCategory}
                        moreTo="/courses"
                    />
                    )} */}

                    {userDoc && (
                    <MyCoursesSlide
                        selectedCategory={selectedCategory}
                        moreTo="/courses"
                    />
                    )}
 
                   {/*  <CourseUpdate
                        selectedCategory={selectedCategory}
                        moreTo="/courses"
                    />  */}

                    <Course2_79
                        selectedCategory={selectedCategory}
                        moreTo="/courses"
                    />

                    <HomepageReviews />

                    <VideoUpdate
                        kind="appetizer"
                        title="ปรับพื้นฐานเรียกน้ำย่อย"
                        selectedCategory={selectedCategory}
                        moreTo="/videos?kind=appetizer"
                    />

                    <br />

                    {/* <CourseCalendarSlide selectedCategory={selectedCategory} /> */}
                    <CourseScheduleSlide selectedCategory={selectedCategory} />

                    <VideoUpdate
                        kind="shorts_prepare_for_exams"
                        title="เทคนิคการเรียน"
                        selectedCategory={selectedCategory}
                        moreTo="/videos?kind=shorts_prepare_for_exams"
                    />

                    <br/>

                    <VideoUpdate
                        kind="oral_exam_tips"
                        title="ติวสอบปากเปล่า"
                        selectedCategory={selectedCategory}
                        moreTo="/videos?kind=oral_exam_tips"
                    />


               {/*  <VideoUpdate
                    kind="youtube"
                    title="YouTube"
                    selectedCategory={selectedCategory}
                    moreTo="/videos?kind=youtube"
                />

                <br />

                <VideoUpdate
                    kind="podcast"
                    title="Podcast"
                    selectedCategory={selectedCategory}
                    moreTo="/videos?kind=podcast"
                /> */}

                {/* <br />

                <VideoUpdate
                    kind="shorts"
                    title="Shorts"
                    selectedCategory={selectedCategory}
                    moreTo="/videos?kind=shorts"
                /> */}

                {/* ✅ VideoUpdate (อนาคต) */}
                {/*
                <VideoUpdate
                kind="youtube"
                title="YouTube"
                selectedCategory={selectedCategory}
                moreTo="/videos/youtube"
                />
                <br />
                <VideoUpdate
                kind="podcast"
                title="Podcast"
                selectedCategory={selectedCategory}
                moreTo="/videos/podcast"
                />
                */}
                        {/* <br/> */}
                    {/* Hero EnChat + ปุ่ม CTA */}
                    {/* <div className="enchat-hero-wrapper">
                        <img
                        className="d-block w-100 enchat-hero-image"
                        src={ChicChic_hero_01}
                        alt="EnChat Hero"
                        style={{ borderRadius: 10 }}
                        />
                    </div>
                        <br/>
                            <UpdateArticle/> */}
                       {/*  <br/>
                    <div className="enchat-hero-wrapper">
                        <img
                        className="d-block w-100 enchat-hero-image"
                        src={ChicChic_hero_02}
                        alt="EnChat Hero"
                        style={{ borderRadius: 10 }}
                        />
                    </div> */}
                    {/* <br/>
                    <VideoRowScrollMock/> */}
                    {/* <br/>
                    <LoginPromptSection/> */}
                    <br/>
                     {/* Hero EnChat + ปุ่ม CTA */}
                    <div className="enchat-hero-wrapper">
                        <img
                        className="d-block w-100 enchat-hero-image"
                        src={tutor_2026}
                        alt="chicchic Hero"
                        style={{ borderRadius: 10 }}
                        />

                       
                        {/* <div className="enchat-hero-cta-wrapper">
                        <Link to="">
                            <button type="button" className="btn enchat-hero-cta">
                            คอร์สออนไลน์
                            </button>
                        </Link>
                        </div> */}
                    </div>
                    <br/>
                    <BrowseCategory/>
            </Container>

            <br/>
            <br/>
            <Container>
            <YoutubePodcastUpdate selectedCategory={selectedCategory} />
            </Container>

             
            <Container className="pt-4 pb-5">
                <RecommendedVideoListWideSection />
                {/* <RecommendedArticleListWideSection/> */}
            </Container>
                

        
        </div>

  );
}

export default HomeDefault;